import { MS_INBOX_READ_CHAT_PATH, MS_INBOX_UNREAD_CHAT_PATH } from '../../constants/AppConstants';
import fetchWithTimeout from '../../util/fetchWithTimeout';
import { msInboxApiUrl, buildMsInboxAuthHeaders, requireMsApiPlatforms } from './msInboxClient';

async function sendChatReadState(payload, path, action) {
  const validChats = requireMsApiPlatforms(payload?.chats, action);

  if (validChats.length === 0) {
    return null;
  }

  const url = msInboxApiUrl(path);
  const headers = await buildMsInboxAuthHeaders();

  const response = await fetchWithTimeout(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ ...payload, chats: validChats }),
    mode: 'cors'
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => ({}));
    const errorMessage = errorDetails.message
      || errorDetails.error
      || errorDetails?.errors
      || `HTTP error! Status: ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  const json = await response.json().catch(() => null);

  if (json && typeof json === 'object' && json.summary && typeof json.summary === 'object') {
    const total = Number(json.summary.total);
    const successful = Number(json.summary.successful);
    if (total > 0 && successful === 0) {
      const error = new Error(
        json.message || `Microservice ${action} batch failed`
      );
      error.status = response.status;
      throw error;
    }
  }

  return json;
}

/**
 * PUT read_chat contra el microservicio inbox.
 * @param {{ chats: Array<{ id: *, platform: string }> }} payload
 */
export function readChatMsInbox(payload) {
  return sendChatReadState(payload, MS_INBOX_READ_CHAT_PATH, 'read_chat');
}

/**
 * PUT unread_chat contra el microservicio inbox.
 * @param {{ chats: Array<{ id: *, platform: string }> }} payload
 */
export function unreadChatMsInbox(payload) {
  return sendChatReadState(payload, MS_INBOX_UNREAD_CHAT_PATH, 'unread_chat');
}

export function sendChatReadStateMsInbox(payload, unreadState) {
  return unreadState ? unreadChatMsInbox(payload) : readChatMsInbox(payload);
}
